//declare permette di "aggiungere" al dizionario typescript delle keyword in modo da permettere la compilazione  
//anche quando non presenti nell'environment
declare var require: any; //non presente nei progetti web. In compilazione si ha l'errore "Cannot find name 'require'."

import { logger } from './logger';
import * as moment from 'moment';

//TODO: non funziona per applicazioni server
//const pkg = require('../../package.json');

export module TrackingUtil {

    const _currentFunctionName = () => {
        let e = new Error();

        // console.log('e.stack :', e.stack);

        let frame = e.stack.split("\n")
                           .filter(stackLine => !["at/","atC:","atstep","atnew","at__awaiter","atObject.next","atObject.<anonymous>"].some(element => stackLine.split(" ").join("").startsWith(element)))[4];


        //console.log('frame :', e.stack.split("\n")
        //.filter(stackLine => !["at/","atstep","atnew","at__awaiter","atObject.next","atObject.<anonymous>"].some(element => stackLine.split(" ").join("").startsWith(element))).join('\n'));

        const fileName = frame.split("at ")[1]
                              .split(" ")[1]
                              .split('(').join('')
                              .split(')').join('')
                              .split('/')
                              .reverse()[0]
                              .split(':')[0];
    
        const functionName = frame.split("at ")[1]
                                  .split(" ")[0]
                                  .split("Object.").join('')
                                  .split("exports.").join('')
    
        return functionName+"()";
    }

    /**
     * Receive an object containing { module: 'hushmail-ui', layer: 'SERVICE', repeated: true|false, 'functionName'}.
     * The passed object could have only some fields
     */
    const _trace = (applicationTransactionId,_startTime,_endTime,_logLevel, _phase, _details, optionalParams?, onlyErrorLogLevelEnabled?) => {
       
        const _functionName = optionalParams?optionalParams.functionName || _currentFunctionName():_currentFunctionName();

        try {
            // console.log('get(APPLICATION_TRANSACTION) :>> ', require('express-http-context').get('APPLICATION_TRANSACTION'));
            
            //questo try-catch serve solo per consentire la compilazione visto che contiene un require dichiarato con un declare
            const eventInstant = ["END","ENDERR"].includes(_phase)?_endTime.format("HH:mm:ss.SSS"):_startTime.format("HH:mm:ss.SSS");
            const logLevel = _logLevel[0];
            //const module = optionalParams?optionalParams.module || pkg.name:pkg.name;
            const layer = optionalParams?optionalParams.layer || "SYS":"SYS";
            const phase = _phase.padEnd(6,"_");
            const elapsed = ["END","ENDERR"].includes(_phase)?moment.utc(_endTime.diff(_startTime)).format("mm:ss.SSS"):"".padEnd(9,"_")//(solo in caso di END o ERROR, negli altri casi fillato con blank)
            const fqn = _functionName.padEnd(60,"_");
            const repeated = optionalParams?optionalParams.repeated || "F":"F";
            const requestId = applicationTransactionId;
            const detail = _details;

            //WITH MODULE NAME INFO
            //const template = `${eventInstant};${logLevel};${repeated};${module};${layer};${fqn};${phase};${elapsed};${detail}`
            const template = `${eventInstant};${logLevel};${repeated};${layer};${fqn};${phase};${elapsed};${requestId?requestId+";":""}${detail}`

            if(![null,undefined].includes(onlyErrorLogLevelEnabled) && onlyErrorLogLevelEnabled){
                if(logLevel=='ERROR')
                    logger[_logLevel](template);
            } 
            else
                logger[_logLevel](template);

        } catch (error) {}

        return _functionName;
    }

    export const start = (applicationTransactionId,optionalParams?, onlyErrorLogLevelEnabled?) => {
        const _now = moment();
        const _logLevel = optionalParams?optionalParams.logLevel||"info":"info";
        const _functionName = _trace(applicationTransactionId,_now,null,_logLevel,"START","",optionalParams,onlyErrorLogLevelEnabled);
        return {
                startTime:_now,
                functionName:_functionName, //Se non era presente tra gli optionalParams, ha provato a ricavarlo dallo stackTrace
                logLevel: _logLevel,
                layer: optionalParams?optionalParams.layer:undefined
               };
    }
    
    export const end = (applicationTransactionId,context,optionalParams?,onlyErrorLogLevelEnabled?) => {
        const _now = moment();

        optionalParams = optionalParams!=null ? optionalParams : {}

        if(!optionalParams.functionName)
            optionalParams.functionName = context.functionName;
        if(!optionalParams.logLevel)
            optionalParams.logLevel = context.logLevel;
        if(!optionalParams.layer)
            optionalParams.layer = context.layer;

        _trace(applicationTransactionId,context.startTime,_now,optionalParams?optionalParams.logLevel||"info":"info","END","",optionalParams,onlyErrorLogLevelEnabled);
    };

    export const endWithError = (applicationTransactionId,context,error,optionalParams?,onlyErrorLogLevelEnabled?) => {
        const _now = moment();

        optionalParams = optionalParams!=null ? optionalParams : {}

        if(!optionalParams.functionName)
            optionalParams.functionName = context.functionName;
        if(!optionalParams.layer)
            optionalParams.layer = context.layer;

        let detail = error.message;
        if(error.cause)
            detail+=` -> cause: ${error.cause.toString().split('\n').join("")}`

        _trace(applicationTransactionId,context.startTime,_now,"error","ENDERR",detail,optionalParams,onlyErrorLogLevelEnabled);
    };


    export const info = (applicationTransactionId,detail,optionalParams?,onlyErrorLogLevelEnabled?) => {
        const now = moment();
        _trace(applicationTransactionId,now,null,"info","INFO",detail,optionalParams,onlyErrorLogLevelEnabled);
    }

    export const debug = (applicationTransactionId,detail,optionalParams?,onlyErrorLogLevelEnabled?) => {
        const now = moment();
        _trace(applicationTransactionId,now,null,"debug","INFO",detail,optionalParams,onlyErrorLogLevelEnabled);
    }

    export const error = (applicationTransactionId,detail,optionalParams?,onlyErrorLogLevelEnabled?) => {
        const now = moment();
        _trace(applicationTransactionId,now,null,"error","ERROR",detail,optionalParams,onlyErrorLogLevelEnabled);
    }
}
